import type { GraphQLFormattedError, GraphQLFormattedErrorExtensions } from 'graphql';
import isObject from 'lodash/isObject';

import { ApiErrorResponseBody } from '../../domain/error/ErrorResponse';

export type ApiErrorResponse = {
  url: string;
  status: number;
  statusText: string;
  body: ApiErrorResponseBody;
};

export type ApiErrorExtensions = {
  code: string;
  response: ApiErrorResponse;
  exception?: {
    stacktrace: string[];
  };
};

export type ApiError = Omit<GraphQLFormattedError, 'extensions'> & {
  extensions: ApiErrorExtensions;
};

export function isApiErrorResponse(response: unknown): response is ApiErrorResponse {
  return (
    isObject(response) &&
    'url' in response &&
    typeof response.url === 'string' &&
    'status' in response &&
    typeof response.status === 'number' &&
    'statusText' in response &&
    typeof response.statusText === 'string' &&
    'body' in response &&
    isObject(response.body)
  );
}

export function isApiErrorExtensions(
  extensions: GraphQLFormattedErrorExtensions
): extensions is ApiErrorExtensions {
  return (
    isObject(extensions) &&
    'code' in extensions &&
    typeof extensions.code === 'string' &&
    isApiErrorResponse(extensions.response)
  );
}

export function isApiError(error: GraphQLFormattedError): error is ApiError {
  return isObject(error.extensions) && isApiErrorExtensions(error.extensions);
}
